import { render } from "./PlayerTitle.vue?vue&type=template&id=107ae792"
import script from "./PlayerTitle.vue?vue&type=script&lang=js"
export * from "./PlayerTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__